import { render, staticRenderFns } from "./crm-dialog-footer.vue?vue&type=template&id=0f8f1193&scoped=true"
import script from "./crm-dialog-footer.vue?vue&type=script&lang=js"
export * from "./crm-dialog-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f1193",
  null
  
)

export default component.exports